import { LookupModelSearchEvent } from "@mcleod/components";
import { LeaveHistory, LeaveHistoryState } from "../LeaveHistory";
import { ModelRow } from "@mcleod/core";
import { AutogenLayoutOfficeLeaveHistory } from "./autogen/AutogenLayoutOfficeLeaveHistory";

export class OfficeLeaveHistory extends AutogenLayoutOfficeLeaveHistory implements LeaveHistoryState {
    postMade: boolean;
    balanceRow: ModelRow<any>;

    override onLoad(): void | Promise<void> {
        new LeaveHistory({
            layout: this,
            beforePayeeLookup: (event: LookupModelSearchEvent) => {
                event.filter.office_employee = "Y";
            }
        });

    }
}
